export default function formatSelectOptions(data) {
  return data.map(name => ({ label: name, value: name }));
}
